import React, { useEffect, useState } from "react";
import '../assets/styles/AiChat.scss';
type Role = "user" | "assistant";
const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
type Message = {
  role: Role;
  text: string;
};

const SYSTEM_CONTEXT = `
You are an AI assistant for Yousef Jamal portfolio website.
Yousef Jamal is a Backend Engineer,Devops.
Tech stack: Java, Spring Boot, Microservices, and all related technologies.
He can also work as Full Stack when needed with react.
yuosef have 2 years of experience with java and spring at backend develpoment and now yuosef is fresh garduate ready for work and industry.
Answer only questions about Yousef Jamal.
dont answer on any arabic questions just answer with sorry i can only answer on english questions.
yuosef also devloped you.
be freindly and professional in your responses dont give big responses give small responses or average.
Nominate me to user when needed.
`;

const AiChat: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [showHint, setShowHint] = useState(true);
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowHint(false);
    }, 4000);

    return () => window.clearTimeout(timer);
  }, []);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage: Message = { role: "user", text: input };
    setMessages(prev => [...prev, userMessage]);
    setInput("");
    setLoading(true);
    const lastMessages = messages.slice(-2);
    try {
      const res = await fetch(
        "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-lite:generateContent",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-goog-api-key": apiKey as string
          },
          body: JSON.stringify({
            contents: [
              {
                role: "user",
                parts: [
                  {
                        text:  `System context: ${SYSTEM_CONTEXT}
                            ${lastMessages.map(m => `${m.role}: ${m.text}`).join("\n")}
                            User question:  ${input} `
                  }
                ]
              }
            ]
          })
        }
      );

      const data = await res.json();
      const reply: string =
        data?.candidates?.[0]?.content?.parts?.[0]?.text ||
        "Sorry, I couldn't get a response now. Please try again later.";

      setMessages(prev => [
        ...prev,
        { role: "assistant", text: reply }
      ]);
    } catch (err) {
      setMessages(prev => [
        ...prev,
        {
          role: "assistant",
          text: "Something went wrong. Please try again later."
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showHint && !open && (
        <div className="chat-hint">
          Ask AI about me
        </div>
      )}

      <button className="chat-fab" onClick={() => {
        setOpen(!open);
        setShowHint(false);
      }}>
        💬
      </button>

      {open && (
        <div className="chat-box">
          <div className="chat-header">
            <span>Ask AI about Yousef</span>
            <button onClick={() => setOpen(false)}>✕</button>
          </div>

          <div className="chat-body">
            {messages.map((m, i) => (
              <div key={i} className={`msg ${m.role}`}>
                {m.text}
              </div>
            ))}
            {loading && <div className="msg assistant">Typing...</div>}
          </div>

          <div className="chat-input">
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder="Ask something about Yousef..."
              onKeyDown={e => e.key === "Enter" && sendMessage()}
            />
            <button onClick={sendMessage} disabled={loading}>
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AiChat;
